import type React from 'react';

import { isAvailableNow, useAvailablePeriod } from '@entities/available-periods';
import { useTz } from '@entities/schedules';
import cn from 'classnames';
import format from 'date-fns/format';

import { getSessionBlock } from '@shared/helpers';

import * as st from './styles.module.scss';

interface Props {
	start: Date;
	end: Date;
	availableId: number;
	isEmpty?: boolean;
}

export const DayStartTime: React.FC<Props> = ({ availableId, start, end, isEmpty = false }) => {
	const { availablePeriod } = useAvailablePeriod(availableId);
	const { tz } = useTz();

	const blockType = getSessionBlock(
		{ start, end },
		tz,
		availablePeriod?.start_time,
		availablePeriod?.end_time
	);

	const isNow = isAvailableNow(availablePeriod);

	const halfHour = () => format(start, 'mm') === '30';

	return (
		<div
			className={cn(
				st.time,
				st[blockType],
				isEmpty && st.empty,
				halfHour() && st.halfHour,
				isNow && st.now
			)}
			onMouseOver={(e) => e.stopPropagation()}
		>
			{(blockType === 'start' || blockType === 'start_topOverlap' || blockType === 'single') && (
				<span>{format(start, 'HH:mm')}</span>
			)}
		</div>
	);
};
